import { useCallback } from 'react';
import { registerOfflineAppMocks, unregisterOfflineAppMocks } from 'offline/offlineAppMocks';
import { isVirtualTourEnabled } from 'offline/utils';

const getChildAppMockRoutes = (remoteApp) => {
    const routeSources = [
        remoteApp?.offlineMockRoutes,
    ].filter(Boolean);

    return routeSources.flatMap((value) => Array.isArray(value)
        ? value
        : (value && typeof value === 'object' ? Object.values(value) : [value]));
};

const getChildAppOrigins = (remoteApp) => {
    const originSources = [
        remoteApp?.offlineOrigins,
        remoteApp?.offlineOrigin,
    ].filter(Boolean);

    return originSources.flatMap((value) => Array.isArray(value)
        ? value
        : (value && typeof value === 'object' ? Object.values(value) : [value]));
};

const useChildAppOfflineMocks = ({ serviceKey }) => {
    const registerChildAppOfflineMocks = useCallback((remoteApp) => {
        const isVirtualTourMode = isVirtualTourEnabled();
        // Register the child app's mock APIs and origin metadata before the app is mounted into the shadow DOM.
        if (isVirtualTourMode && remoteApp?.offlineMockRoutes && remoteApp?.offlineOrigins) {
            const childAppMockRoutes = getChildAppMockRoutes(remoteApp);
            const childAppOrigins = getChildAppOrigins(remoteApp);

            if ((childAppMockRoutes && childAppMockRoutes.length) || (childAppOrigins && childAppOrigins.length)) {
                registerOfflineAppMocks({ appId: serviceKey, routes: childAppMockRoutes, origins: childAppOrigins });
            }
        }
    }, [serviceKey]);

    const unregisterChildAppOfflineMocks = useCallback(() => {
        if (serviceKey && isVirtualTourEnabled()) {
            unregisterOfflineAppMocks({ appId: serviceKey });
        }
    }, [serviceKey]);

    return { registerChildAppOfflineMocks, unregisterChildAppOfflineMocks };
};

export default useChildAppOfflineMocks;
